(() => {
  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim();

  function exactTextElements(root, text, selector = '*') {
    return [...root.querySelectorAll(selector)].filter((element) => normalize(element.textContent) === text);
  }

  function findUpsellRoot() {
    const existing = document.querySelector('.mebore-cart-upsell');
    if (existing) return existing;
    const cartItems = document.querySelector('cart-items');
    if (!cartItems) return null;
    const heading = exactTextElements(cartItems, '一緒にチェックされている人気アイテム', 'h1,h2,h3,h4,h5,h6,div,p,span')[0];
    if (!heading) return null;

    let candidate = heading.parentElement;
    while (candidate && candidate !== cartItems) {
      const addButtons = exactTextElements(candidate, 'カートに追加', 'button');
      if (addButtons.length >= 1 && candidate.querySelectorAll('img').length >= 1) return candidate;
      candidate = candidate.parentElement;
    }
    return null;
  }

  function findCard(button, root) {
    let node = button.parentElement;
    let candidate = null;
    while (node && node !== root) {
      const buttons = exactTextElements(node, 'カートに追加', 'button');
      if (buttons.length === 1 && node.querySelector('img')) candidate = node;
      node = node.parentElement;
    }
    return candidate;
  }

  function findCommonContainer(cards, root) {
    if (!cards.length) return null;
    let node = cards[0].parentElement;
    while (node && node !== root) {
      if (cards.every((card) => node.contains(card))) return node;
      node = node.parentElement;
    }
    return null;
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>'"]/g, (character) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
    })[character]);
  }

  function money(value) {
    const numeric = Number(value);
    const amount = typeof value === 'number' ? Math.round(numeric / 100) : Math.round(numeric);
    return `¥${amount.toLocaleString('ja-JP')}`;
  }

  function imageSource(image) {
    return typeof image === 'string' ? image : image?.src;
  }

  function imageWithWidth(source, width) {
    if (!source) return '';
    const separator = source.includes('?') ? '&' : '?';
    return `${source}${separator}width=${width}`;
  }

  function responsiveImageMarkup(source, title) {
    const safeTitle = escapeHtml(title);
    return `<img
      class="mebore-cart-upsell__image"
      src="${escapeHtml(imageWithWidth(source, 520))}"
      srcset="${escapeHtml(imageWithWidth(source, 240))} 240w, ${escapeHtml(imageWithWidth(source, 360))} 360w, ${escapeHtml(imageWithWidth(source, 520))} 520w, ${escapeHtml(imageWithWidth(source, 720))} 720w"
      sizes="(max-width: 749px) 56vw, (max-width: 989px) 15vw, 130px"
      alt="${safeTitle}"
      width="520"
      height="520"
      loading="lazy"
    >`;
  }

  async function refreshCartPage(upsellRoot) {
    const response = await fetch('/cart', { headers: { Accept: 'text/html' } });
    if (!response.ok) throw new Error('Cart refresh failed');
    const nextDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
    const items = document.getElementById('main-cart-items');
    const footer = document.getElementById('main-cart-footer');
    const nextItems = nextDocument.querySelector('#main-cart-items .js-contents');
    const nextFooter = nextDocument.querySelector('#main-cart-footer .js-contents');
    if (!items || !footer || !nextItems || !nextFooter) {
      throw new Error('Cart sections unavailable');
    }

    upsellRoot?.remove();
    items.querySelector('.js-contents').innerHTML = nextItems.innerHTML;
    footer.querySelector('.js-contents').innerHTML = nextFooter.innerHTML;
    if (upsellRoot) footer.querySelector('[data-cart-upsell-slot]')?.appendChild(upsellRoot);

    const bubble = document.getElementById('cart-icon-bubble');
    const nextBubble = nextDocument.getElementById('cart-icon-bubble');
    if (bubble && nextBubble) bubble.innerHTML = nextBubble.innerHTML;
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    window.requestAnimationFrame(enhanceUpsell);
  }

  async function addRecommendationToCart(variantId, button) {
    const root = button.closest('.mebore-cart-upsell');
    const originalLabel = button.textContent;
    button.disabled = true;
    button.textContent = '追加中…';
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }]
        })
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || 'Cart add failed');
      await refreshCartPage(root);
      button.textContent = '追加しました';
      window.setTimeout(() => {
        if (button.isConnected) {
          button.disabled = false;
          button.textContent = originalLabel;
        }
      }, 1000);
    } catch (error) {
      button.dataset.addError = error instanceof Error ? error.message : String(error);
      console.error('[Mebore cart] Recommendation add failed:', error);
      button.disabled = false;
      button.textContent = '追加できませんでした';
      window.setTimeout(() => {
        if (button.isConnected) button.textContent = originalLabel;
      }, 1800);
    }
  }

  function unifiedRecommendationCard(product, brandMode, source = 'custom') {
    const availableVariants = (product.variants || []).filter((variant) => variant.available);
    const sourceImage = imageSource(product.featured_image) || imageSource(product.images?.[0]);
    if (!availableVariants.length || !sourceImage) return null;

    const card = document.createElement('article');
    card.className = `mebore-cart-upsell__card mebore-cart-upsell__card--unified mebore-cart-upsell__card--${source}`;
    const productUrl = `/products/${product.handle}`;
    const safeTitle = escapeHtml(product.title);
    const vendor = brandMode === 'mixed' ? `<p class="mebore-cart-upsell__vendor">${escapeHtml(product.vendor)}</p>` : '';
    const options = availableVariants.map((variant) =>
      `<option value="${variant.id}">${escapeHtml(variant.title)}</option>`
    ).join('');

    card.innerHTML = `
      <a class="mebore-cart-upsell__image-link" href="${productUrl}">
        ${responsiveImageMarkup(sourceImage, product.title)}
      </a>
      <div class="mebore-cart-upsell__content">
        ${vendor}
        <a class="mebore-cart-upsell__title" href="${productUrl}">${safeTitle}</a>
        <p class="mebore-cart-upsell__price">${money(availableVariants[0].price)}</p>
        <select class="mebore-cart-upsell__select" aria-label="${safeTitle}のカラー・サイズ">${options}</select>
        <button class="mebore-cart-upsell__add" type="button">カートに追加</button>
      </div>
    `;

    const select = card.querySelector('select');
    const price = card.querySelector('.mebore-cart-upsell__price');
    select.addEventListener('change', () => {
      const variant = availableVariants.find((item) => String(item.id) === select.value);
      if (variant) price.textContent = money(variant.price);
    });
    card.querySelector('button').addEventListener('click', (event) => {
      addRecommendationToCart(select.value, event.currentTarget);
    });
    return card;
  }

  function updateUpsellColumnCount(list) {
    if (!list) return;
    const visibleCards = [...list.querySelectorAll('.mebore-cart-upsell__card')]
      .filter((card) => !card.classList.contains('is-brand-mismatch'));
    list.style.setProperty('--mebore-upsell-columns', Math.min(visibleCards.length, 6) || 1);
  }

  function applyBrandRecommendationVisibility(list, brandMode) {
    if (!list || brandMode === 'ladies') return;
    const appCards = [...list.querySelectorAll('.mebore-cart-upsell__card:not(.mebore-cart-upsell__card--custom)')];
    appCards.forEach((card, index) => {
      card.classList.toggle('is-brand-mismatch', brandMode === 'mens' || index > 1);
    });
  }

  function normalizeAppRecommendations(root, list, brandMode) {
    if (!list || brandMode === 'mens') return;
    const appCards = [...list.querySelectorAll('.mebore-cart-upsell__card:not(.mebore-cart-upsell__card--unified):not(.mebore-cart-upsell__card--custom)')];
    appCards.forEach((card) => {
      if (card.classList.contains('is-brand-mismatch') || card.dataset.normalizing) return;
      const productLink = card.querySelector('a[href*="/products/"]');
      const handle = productLink?.pathname.match(/\/products\/([^/?#]+)/)?.[1];
      if (!handle) return;
      card.dataset.normalizing = 'true';
      fetch(`/products/${handle}.js`)
        .then((response) => response.ok ? response.json() : Promise.reject())
        .then((product) => {
          if (!card.isConnected) return;
          const unifiedCard = unifiedRecommendationCard(product, brandMode, 'app');
          if (!unifiedCard) throw new Error('Recommendation unavailable');
          if (card.classList.contains('is-brand-mismatch')) unifiedCard.classList.add('is-brand-mismatch');
          card.replaceWith(unifiedCard);
          updateUpsellColumnCount(list);
        })
        .catch(() => {
          delete card.dataset.normalizing;
        });
    });
  }

  function ensureBrandRecommendations(root, list, brandMode) {
    if (!list || brandMode === 'ladies') return;
    if (root.dataset.brandRecommendations === 'loading') return;
    if (root.dataset.brandRecommendations === 'ready' && root.querySelector('.mebore-cart-upsell__card--custom')) return;
    root.dataset.brandRecommendations = 'loading';

    const cartHandles = new Set([...document.querySelectorAll('.cart-item__name[href*="/products/"]')]
      .map((link) => link.pathname.match(/\/products\/([^/?#]+)/)?.[1])
      .filter(Boolean));
    fetch('/collections/mens-ranking/products.json?limit=12')
      .then((response) => response.ok ? response.json() : Promise.reject())
      .then((data) => {
        const products = (data.products || [])
          .filter((product) => product.vendor === "MEN'S MEBORE" && !cartHandles.has(product.handle));
        const targetCount = brandMode === 'mixed' ? 3 : 5;
        const customCards = products.slice(0, targetCount)
          .map((product) => unifiedRecommendationCard(product, brandMode, 'custom'))
          .filter(Boolean);
        if (!customCards.length) throw new Error('No MEN\'S recommendations');

        applyBrandRecommendationVisibility(list, brandMode);
        list.querySelectorAll('.mebore-cart-upsell__card--custom').forEach((card) => card.remove());
        customCards.forEach((card) => list.appendChild(card));
        root.dataset.brandRecommendations = 'ready';
        normalizeAppRecommendations(root, list, brandMode);
        updateUpsellColumnCount(list);
      })
      .catch(() => {
        root.dataset.brandRecommendations = 'failed';
      });
  }

  function decorateHeading(root) {
    const candidates = exactTextElements(root, '一緒にチェックされている人気アイテム', 'h1,h2,h3,h4,h5,h6,div,p,span');
    const text = candidates.find((element) => element.children.length === 0) || candidates[candidates.length - 1];
    if (!text) return;
    let wrapper = text;
    while (wrapper.parentElement && wrapper.parentElement !== root && wrapper.querySelectorAll('button').length < 1) {
      wrapper = wrapper.parentElement;
    }
    wrapper.classList.add('mebore-cart-upsell__heading');
    text.classList.add('mebore-cart-upsell__heading-text');
    const navigation = [...wrapper.children].find((child) => child !== text && child.querySelector('button'));
    navigation?.classList.add('mebore-cart-upsell__navigation');
  }

  function enhanceUpsell() {
    const root = findUpsellRoot();
    const slot = document.querySelector('[data-cart-upsell-slot]');
    if (!root || !slot) return;
    root.classList.add('mebore-cart-upsell');
    if (root.parentElement !== slot) slot.appendChild(root);
    decorateHeading(root);

    const addButtons = exactTextElements(root, 'カートに追加', 'button');
    const cards = [...new Set(addButtons.map((button) => findCard(button, root)).filter(Boolean))];
    cards.forEach((card) => card.classList.add('mebore-cart-upsell__card'));
    const list = findCommonContainer(cards, root) || root.querySelector('.mebore-cart-upsell__list');
    if (list) list.classList.add('mebore-cart-upsell__list');

    const brandMode = document.getElementById('main-cart-footer')?.dataset.cartBrand || 'ladies';
    applyBrandRecommendationVisibility(list, brandMode);
    ensureBrandRecommendations(root, list, brandMode);
    normalizeAppRecommendations(root, list, brandMode);
    updateUpsellColumnCount(list);
  }

  function initStickyCheckout() {
    const mobileMedia = window.matchMedia('(max-width: 749px)');
    let ticking = false;
    const sync = () => {
      const sticky = document.querySelector('[data-cart-sticky-checkout]');
      const checkout = document.querySelector('#checkout');
      if (!sticky || !checkout) return;
      const rect = checkout.getBoundingClientRect();
      const checkoutVisible = rect.top < window.innerHeight - 24 && rect.bottom > 24;
      const show = mobileMedia.matches && !checkout.disabled && !checkoutVisible;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    };
    const requestSync = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        sync();
        ticking = false;
      });
    };

    window.addEventListener('scroll', requestSync, { passive: true });
    window.addEventListener('resize', requestSync);
    window.addEventListener('pageshow', requestSync);
    document.addEventListener('cart:updated', requestSync);
    mobileMedia.addEventListener?.('change', requestSync);
    requestSync();
  }

  function init() {
    enhanceUpsell();
    initStickyCheckout();
    const observer = new MutationObserver(() => window.requestAnimationFrame(enhanceUpsell));
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
